import { ROUTER_NAMES } from './routerNamesConfig'
import { MACHINES_CARD_CONFIG } from '@/config/router/companyCards/machineCardConfig'
import { FIELDS_CARD_CONFIG } from '@/config/router/companyCards/fieldCardConfig'
import { STAFF_CARD_CONFIG } from '@/config/router/companyCards/staffCardConfig'

export const COMPANY_CARDS = [
	MACHINES_CARD_CONFIG,
	{
		path: 'regulation/:cardId',
		name: ROUTER_NAMES.REGULATIONS.CARD,
		component: () => import('@/views/company/cards/regulation/CompanyDashboardCardRegulationView.vue'),
	},
	// {
	// 	// TODO: RegulationStagesPopup by TONY
	//FIXME: CHECK!!!!!!!!!!
	// 	path: '',
	// 	name: 'CompanyCardRegulationStagesPage',
	// 	component: () => import('@/views/company/cards/regulation/CompanyCardRegulationView.vue'),
	// },
	{
		path: 'crop-distribution/:cardId',
		name: ROUTER_NAMES.CROPS_STRUCTURES.CARD,
		component: () => import('@/views/company/cards/crop/CompanyCardCropBusinessProcessView.vue'),
	},
	FIELDS_CARD_CONFIG,
	STAFF_CARD_CONFIG,
]
